import { jsx as i } from "react/jsx-runtime";
import "../../utils/sectionPreview.js";
import "react";
import s from "clsx";
import { ArrowLeftIcon as l } from "../../icons/ArrowLeftIcon.js";
import { Button as _ } from "../Button/Button.js";
import "next/link";
import "../../_chunks/RadioRatingStarButton.G-PJJfn0.js";
import "js-cookie";
import "../Combobox/Combobox.js";
import "../Datepicker/Datepicker.js";
import "@portabletext/react";
import "../Grid/Col/Col.js";
import "react-is";
import "../IconButton/IconButton.js";
import "next/image";
import "../Input/Input.js";
import "@hookform/error-message";
import "../Modal/constants.js";
import "../Modal/ModalContent.js";
import "../Modal/ModalFooter.js";
import "../Modal/ModalHeader.js";
import "../Modal/ModalContext.js";
import "../RadioButton/RadioButton.js";
import "../Switch/Switch.js";
import '../../_assets/LinkToBack._yZfHFG4.css';const k = "_link_1kaae_44", c = "_grayVariant_1kaae_52", r = {
  link: k,
  grayVariant: c,
  "slide-in-out": "_slide-in-out_1kaae_1",
  "fade-in-out": "_fade-in-out_1kaae_1"
}, H = ({
  href: t,
  title: o = "",
  className: m,
  iconClassName: a,
  icon: p = /* @__PURE__ */ i(l, {}),
  isDisabled: n,
  variantColor: e = "green"
}) => /* @__PURE__ */ i(
  _,
  {
    href: t,
    icon: p,
    theme: "new",
    variant: "link",
    size: "small",
    disabled: n,
    className: s(r.link, m, e === "gray" && r.grayVariant),
    iconClassName: a,
    children: o
  }
);
export {
  H as LinkToBack
};
